import React from "react";
import { ContactForm, Navbar } from "../components";

const About = () => {
  return (
    <div>
      <div className="gradient-bg-welcome">
        <Navbar />
        <ContactForm />
      </div>
    </div>
  );
};

export default About;
